import { z } from 'zod';
import { utcTimestampSchema, uuidSchema } from './primitives';

export const ATTACHMENT_OWNER_TYPES = ['task', 'followUpLog'] as const;
export const attachmentOwnerTypeSchema = z.enum(ATTACHMENT_OWNER_TYPES);

export const ATTACHMENT_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'] as const;
export const attachmentMimeTypeSchema = z.enum(ATTACHMENT_MIME_TYPES);

/** 單張建議上限 8 MiB。 */
export const ATTACHMENT_SIZE_LIMIT = 8 * 1024 * 1024;

/** 匯出到 data.json 的附件 metadata，不含任何 Blob。 */
export const attachmentMetaSchema = z.object({
  id: uuidSchema,
  ownerType: attachmentOwnerTypeSchema,
  ownerId: uuidSchema,
  fileName: z.string().min(1),
  mimeType: attachmentMimeTypeSchema,
  originalSize: z.number().int().nonnegative(),
  size: z.number().int().nonnegative(),
  width: z.number().int().positive(),
  height: z.number().int().positive(),
  sha256: z.string().regex(/^[0-9a-f]{64}$/, '必須是 64 位十六進位雜湊'),
  createdAt: utcTimestampSchema,
});

/** 資料庫中的附件另外帶原圖與縮圖 Blob。 */
export const attachmentSchema = attachmentMetaSchema.extend({
  blob: z.instanceof(Blob),
  thumbnailBlob: z.instanceof(Blob),
});

export type AttachmentOwnerType = z.infer<typeof attachmentOwnerTypeSchema>;
export type AttachmentMimeType = z.infer<typeof attachmentMimeTypeSchema>;
export type AttachmentMeta = z.infer<typeof attachmentMetaSchema>;
export type Attachment = z.infer<typeof attachmentSchema>;
